import { FC, useEffect, useState } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import { Card, Col, Image, Row, SimpleCollapse, Span } from 'components'
import { PERMITIONS } from 'components/DrawerMenu/routes_list'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useAuth, useLoading, useModal, useReportPrint } from 'hooks'
import {
  IHandlePrintConsolidacaoEfetivo,
  IRelatorioFolhaPagamentoContent
} from 'hooks/useReportPrint/types'
import {
  ReportsConsolidationServices,
  IConsolidacaoTableEntity
} from 'services/NGT/EffectiveConsolidation'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'

import { downloadURI } from '../../EffectiveConsolidation'
import { ReportTable } from './components/ReportTable/ReportTable'
import { FormatNumber } from '../Shared/FormatNumber'

interface ICollapsesPropsPDF {
  collapseTitle: string
  tableTitle: string
}

interface IReportPayroll {
  flRecorrente: boolean
}

const ReportPayroll: FC<IReportPayroll> = ({ flRecorrente }) => {
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()
  const { handlePrintFolhaPagamento } = useReportPrint()
  const { user } = useAuth()

  const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear())

  const [isGeneratePDF] = useState<boolean>(false)
  const [reportPayrollByArea, setReportPayrollByArea] =
    useState<IConsolidacaoTableEntity>()
  const [reportPayrollByCompany, setReportPayrollByCompany] =
    useState<IConsolidacaoTableEntity>()
  const [reportPayrollByExecutive, setReportPayrollByExecutive] =
    useState<IConsolidacaoTableEntity>()
  const [reportPayrollByUnit, setReportPayrollByUnit] =
    useState<IConsolidacaoTableEntity>()

  const collapsesTitles: ICollapsesPropsPDF[] = [
    {
      collapseTitle: 'Distribuição por Diretoria Executiva',
      tableTitle: 'Diretoria Executiva'
    },
    {
      collapseTitle: 'Distribuição por Empresas',
      tableTitle: 'Empresa'
    },
    {
      collapseTitle: 'Distribuição por Área',
      tableTitle: 'Área'
    },
    {
      collapseTitle: 'Distribuição por Unidade de Negócio',
      tableTitle: 'Unidade Negócio'
    }
  ]

  const GenerateExcelPayroll = async () => {
    setLoading('loading')

    ReportsConsolidationServices()
      .GetExcelPagamentoEfetivo(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )
      .then((response) => {
        if (response.status === 200) {
          downloadURI(response.data, `Folha-de-Pagamento.xlsx`)
        }
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem ||
            error.message ||
            'Não foi possivel fazer o download da planilha, tente novamente!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleClickPdfReport = async () => {
    setLoading('loading')

    try {
      setLoading('idle')

      const pdfDataArray: IRelatorioFolhaPagamentoContent[] = []

      collapsesTitles.forEach((collapseTitle) => {
        reportPayrollByExecutive.items.map(x => x.variacao = FormatNumber.formatarNumero(x.variacao) as unknown as number)
        reportPayrollByCompany.items.map(x => x.variacao = FormatNumber.formatarNumero(x.variacao) as unknown as number)
        reportPayrollByArea.items.map(x => x.variacao = FormatNumber.formatarNumero(x.variacao) as unknown as number)
        reportPayrollByUnit.items.map(x => x.variacao = FormatNumber.formatarNumero(x.variacao) as unknown as number)

        pdfDataArray.push({
          anoAnterior: currentYear - 1,
          anoAtual: currentYear,
          body:
            collapseTitle.collapseTitle ===
              'Distribuição por Diretoria Executiva'
              ? reportPayrollByExecutive?.items.map((item, index) => {
                const effectiveByExecutiveArray: (string | number)[][] = [] // Array auxiliar
                // Criando as listas principais
                effectiveByExecutiveArray.push([
                  item?.nmGrupoConsolidacao.toUpperCase(),
                  item?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  item?.variacao
                ])
                // Adicionando as listas de subItens
                item.unidadeGestoraInfo.forEach((subItem) =>
                  effectiveByExecutiveArray.push([
                    FORMAT.capitalizeString(
                      subItem?.nmUnidadeGestora.toLowerCase()
                    ),
                    subItem?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    subItem?.variacao
                  ])
                )
                !reportPayrollByExecutive.items[index + 1] && effectiveByExecutiveArray.push([
                  "Total",
                  reportPayrollByExecutive?.total[12]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[0]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[1]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[2]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[3]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[4]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[5]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[6]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[7]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[8]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[9]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[10]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                  reportPayrollByExecutive?.total[11]?.info?.vlPagamento?.toLocaleString(
                    'pt-br',
                    { currency: 'BRL', style: 'currency' }
                  ),
                ])
                return effectiveByExecutiveArray
              })
              : collapseTitle.collapseTitle === 'Distribuição por Empresas'
                ? reportPayrollByCompany?.items.map((item, index) => {
                  const effectiveByCompanyArray: (string | number)[][] = [] // Array auxiliar
                  // Criando as listas principais
                  effectiveByCompanyArray.push([
                    item?.nmGrupoConsolidacao.toUpperCase(),
                    item?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    item?.variacao
                  ])
                  // Adicionando as listas de subItens
                  item.unidadeGestoraInfo.forEach((subItem) =>
                    effectiveByCompanyArray.push([
                      FORMAT.capitalizeString(
                        subItem?.nmUnidadeGestora.toLowerCase()
                      ),
                      subItem?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      subItem?.variacao
                    ])
                  )
                  !reportPayrollByCompany.items[index + 1] && effectiveByCompanyArray.push([
                    "Total",
                    reportPayrollByCompany?.total[12]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[0]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[1]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[2]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[3]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[4]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[5]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[6]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[7]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[8]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[9]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[10]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                    reportPayrollByCompany?.total[11]?.info?.vlPagamento?.toLocaleString(
                      'pt-br',
                      { currency: 'BRL', style: 'currency' }
                    ),
                  ])
                  return effectiveByCompanyArray
                })
                : collapseTitle.collapseTitle === 'Distribuição por Área'
                  ? reportPayrollByArea?.items.map((item, index) => {
                    const effectiveByAreaArray: (string | number)[][] = [] // Array auxiliar
                    // Criando as listas principais
                    effectiveByAreaArray.push([
                      item?.nmGrupoConsolidacao.toUpperCase(),
                      item?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      item?.variacao
                    ])
                    // Adicionando as listas de subItens
                    item.unidadeGestoraInfo.forEach((subItem) =>
                      effectiveByAreaArray.push([
                        FORMAT.capitalizeString(
                          subItem?.nmUnidadeGestora.toLowerCase()
                        ),
                        subItem?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        subItem?.variacao
                      ])
                    )
                    !reportPayrollByArea.items[index + 1] && effectiveByAreaArray.push([
                      "Total",
                      reportPayrollByArea?.total[12]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[0]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[1]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[2]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[3]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[4]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[5]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[6]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[7]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[8]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[9]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[10]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                      reportPayrollByArea?.total[11]?.info?.vlPagamento?.toLocaleString(
                        'pt-br',
                        { currency: 'BRL', style: 'currency' }
                      ),
                    ])
                    return effectiveByAreaArray
                  })
                  : collapseTitle.collapseTitle ===
                    'Distribuição por Unidade de Negócio'
                    ? reportPayrollByUnit?.items.map((item, index) => {
                      const effectiveByUnityArray: (string | number)[][] = [] // Array auxiliar
                      // Criando as listas principais
                      effectiveByUnityArray.push([
                        item?.nmGrupoConsolidacao.toUpperCase(),
                        item?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        item?.variacao
                      ])
                      // Adicionando as listas de subItens
                      item.unidadeGestoraInfo.forEach((subItem) =>
                        effectiveByUnityArray.push([
                          FORMAT.capitalizeString(
                            subItem?.nmUnidadeGestora.toLowerCase()
                          ),
                          subItem?.informaoAnoMeses[12]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[0]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[1]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[2]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[3]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[4]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[5]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[6]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[7]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[8]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[9]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[10]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.informaoAnoMeses[11]?.info?.vlPagamento?.toLocaleString(
                            'pt-br',
                            { currency: 'BRL', style: 'currency' }
                          ),
                          subItem?.variacao
                        ])
                      )
                      !reportPayrollByUnit.items[index + 1] && effectiveByUnityArray.push([
                        "Total",
                        reportPayrollByUnit?.total[12]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[0]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[1]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[2]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[3]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[4]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[5]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[6]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[7]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[8]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[9]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[10]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                        reportPayrollByUnit?.total[11]?.info?.vlPagamento?.toLocaleString(
                          'pt-br',
                          { currency: 'BRL', style: 'currency' }
                        ),
                      ])
                      return effectiveByUnityArray
                    })
                    : [],
          tableTitle: collapseTitle.tableTitle,
          titleCollapse: collapseTitle.collapseTitle
        })
      })

      if (pdfDataArray) {
        const pdfObject: IHandlePrintConsolidacaoEfetivo = {
          data: pdfDataArray,
          filename: `relatorio-consolidacao-folha-pagamento`
        }
        handlePrintFolhaPagamento(pdfObject)
      } else {
        showModal({
          hideButtonCancel: true,
          message: 'Não há efetivo cadastrado para este contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      }
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message:
          error.mensagem ||
          error.message ||
          'Não foi possivel obter a lista de Efetivos deste contrato',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }

  const HeaderEffectiveConsolidationTitle = () => (
    <Card
      backgroundColor={COLORS.headerColor}
      padding={SPACING.spacing20}
      marginBottom={`-${SPACING.spacing15}`}
    >
      <Row alignItems="center" justifyContent="left">
        <Col gap=".7rem" alignItems="center" justifyContent="left">
          <CsnLogo width="62" height="40" />
          <Image src={Logotipo} width="3.8rem" />
        </Col>
        <Col justifyContent="center" marginLeft={SPACING.spacing200}>
          <Span
            text="RELATÓRIO FOLHA DE PAGAMENTO"
            color={COLORS.blueFonts}
            fontSize="24px"
            fontWeight={FONTS.bold}
            textTransform="uppercase"
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          />
          <Span
            textAlign="center"
            fontWeight="bold"
            fontSize={TYPOGRAPHY.bodySize16}
            color={COLORS.blueFonts}
            text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
            marginTop={SPACING.spacing15}
            marginBottom={SPACING.spacing15}
          />
        </Col>
      </Row>
    </Card>
  )

  const getReportPayroll = async () => {
    setLoading('loading')
    try {
      const response = await ReportsConsolidationServices().GetPagamentoEfetivo(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )

      if (response.status !== 200) {
        throw new Error(response.statusText)
      }

      setCurrentYear(response.data.entity.area?.total?.find((info) => info.mes === 1).ano)

      setReportPayrollByArea(response.data.entity.area)
      setReportPayrollByCompany(response.data.entity.empresa)
      setReportPayrollByExecutive(response.data.entity.diretoria)
      setReportPayrollByUnit(response.data.entity.unidadeNegocio)

      setLoading('idle')
    } catch (error: any) {
      setMsgErro('Erro ao carregar dados do relatório, tente novamente!')
      setLoading('error')
    }
  }

  useEffect(() => {
    getReportPayroll()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <div id="pdfView">
        {isGeneratePDF ? (
          <HeaderEffectiveConsolidationTitle />
        ) : (
          <>
            <Row
              justifyContent="center"
              marginTop={SPACING.spacing15}
              marginBottom={SPACING.spacing5}
            >
              <Span
                textAlign="center"
                fontWeight="bold"
                fontSize={TYPOGRAPHY.bodySize16}
                color={COLORS.blueFonts}
                text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
                marginTop={SPACING.spacing15}
                marginBottom={SPACING.spacing5}
              />
            </Row>
            <Row justifyContent="flex-end">
              <ExcelIcon onClick={() => GenerateExcelPayroll()} />
              <PdfIcon onClick={() => handleClickPdfReport()} />
            </Row>
          </>
        )}
        <Row marginBottom={SPACING.spacing30} />
        <SimpleCollapse
          title="Distribuição por Diretoria Executiva"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportPayrollByExecutive}
            titleHeader="Diretoria Executiva"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Empresas"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportPayrollByCompany}
            titleHeader="Empresa"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Área"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportPayrollByArea}
            titleHeader="Área"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Unidade de Negócio"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportPayrollByUnit}
            titleHeader="Unidade Negócio"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>
      </div>
    </Card>
  )
}

export default ReportPayroll
